module.exports = __webpack_public_path__ + "img/scroll7.31abb8e4.png";